import type { OperationVariables } from '@apollo/client'
import { skipToken, type SkipToken, type useQuery } from '@apollo/client/react'

/**
 * Turns the `skip` option into `skipToken`. A query parked with `skip: true` is still refetched by name
 * from a mutation's `refetchQueries`; one parked with `skipToken` is not.
 */
export const queryOptionsOrSkipToken = <TData, TVariables extends OperationVariables>(
  options: useQuery.Options<TData, TVariables>,
): useQuery.Options<TData, TVariables> | SkipToken => (options.skip ? skipToken : options)
